import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { useL10n } from '@uplift/hooks';

import { CancelButton } from '../../../../Form';
import { ModalActions, ModalContent, ModalTitle } from '../../../../Modal';

import { AddSessionFormSubmitButton } from '../components/AddSessionFormSubmitButton';
import { AddSessionForm } from './AddSessionForm.component';


const useStyles = makeStyles()({
  root: {},
  content: {
    paddingTop: '0 !important',
    maxHeight: 'calc(100vh - 150px)',
  }
});


export type AddSessionFormModalProps = {
  open?: boolean;
  onClose: () => void;
};


export const AddSessionFormModal: React.FC<AddSessionFormModalProps> = (props) => {
  const l10n = useL10n();
  const { classes } = useStyles();

  return (
    <>
      <ModalTitle onClose={props.onClose}>
        {l10n.schedule.createAppointment.newSession}
      </ModalTitle>
      <ModalContent className={classes.content}>
        <AddSessionForm />
      </ModalContent>
      <ModalActions>
        <CancelButton
          // validation error is changing modal height, so CLOSE button is moving down and `onClick` event is not dispatching
          // onMouseDown used because we need to handle click before validation error shown
          onMouseDown={props.onClose}
          size="medium"
        >
          {l10n.general.cancel}
        </CancelButton>
        <AddSessionFormSubmitButton size="medium" color="secondary">
          {l10n.general.save}
        </AddSessionFormSubmitButton>
      </ModalActions>
    </>
  );
};
